import React from "react";
import {
  Box,
  Heading,
  Text,
  Button,
  Stack,
  Flex,
  Image,
  Icon,
  SimpleGrid,
  useColorModeValue,
} from "@chakra-ui/react";
import { FaCarSide, FaMobileAlt, FaShieldAlt } from "react-icons/fa";
import WebLayout from "../layouts/WebLayout";

const Home = () => {
  return (
    <WebLayout>
      <Box>
        {/* Hero Section */}
        <Flex
          direction={{ base: "column", md: "row" }}
          align="center"
          justify="space-between"
          px={12}
          py={24}
          bg={useColorModeValue("gray.100", "gray.900")}
        >
          <Box flex="1">
            <Heading as="h1" size="2xl" mb={4}>
              Your Smart Travel Companion
            </Heading>
            <Text fontSize="xl" mb={6}>
              Find rides, share trips, and save money with ease.
            </Text>
            <Stack direction="row" spacing={4}>
              <Button colorScheme="teal" size="lg">
                Get Started
              </Button>
              <Button variant="outline" colorScheme="teal" size="lg">
                Learn More
              </Button>
            </Stack>
          </Box>
          <Image
            src="https://source.unsplash.com/600x400/?car,road"
            alt="Travel"
            width="500px"
            height="auto"
            objectFit="cover"
            fallbackSrc="https://via.placeholder.com/500x400"
            mt={{ base: 10, md: 0 }}
            ml={{ md: 10 }}
            borderRadius="lg"
          />

        </Flex>

        {/* Features Section */}
        <Box px={8} py={16} bg={useColorModeValue("white", "gray.800")}>
          <Heading textAlign="center" mb={12}>
            Features
          </Heading>
          <SimpleGrid columns={{ base: 1, md: 3 }} spacing={10}>
            <Feature
              icon={FaCarSide}
              title="Easy Ride Matching"
              text="Connect drivers and passengers going the same way."
            />
            <Feature
              icon={FaMobileAlt}
              title="Mobile Friendly"
              text="Access the platform on any device with a modern UI."
            />
            <Feature
              icon={FaShieldAlt}
              title="Secure & Reliable"
              text="Built with secure authentication and real-time data."
            />
          </SimpleGrid>
        </Box>

        {/* CTA Section */}
        <Box
          textAlign="center"
          px={8}
          py={16}
          bg={useColorModeValue("teal.500", "teal.300")}
          color="white"
        >
          <Heading size="xl" mb={4}>
            Ready to hit the road?
          </Heading>
          <Text fontSize="lg" mb={6}>
            Join thousands of users who trust us to share rides daily.
          </Text>
          <Button colorScheme="whiteAlpha" size="lg">
            Sign Up Now
          </Button>
        </Box>
      </Box>
    </WebLayout>
  );
};

const Feature = ({ icon, title, text }) => (
  <Box textAlign="center" px={4}>
    <Icon as={icon} w={12} h={12} color="teal.400" mb={4} />
    <Heading fontSize="xl" mb={2}>
      {title}
    </Heading>
    <Text>{text}</Text>
  </Box>
);

export default Home;
